import React from 'react';
import './Preloader.css';

const Preloader = ({ message = "Loading...", fullScreen = true }) => {
  return (
    <div className={`vxp-preloader ${fullScreen ? 'vxp-preloader--full' : 'vxp-preloader--inline'}`}>
      <div className="vxp-preloader__spinner">
        <div className="vxp-preloader__ring"></div>
        <div className="vxp-preloader__ring"></div>
      </div>
      <div className="vxp-preloader__text">{message}</div>
    </div>
  );
};

export default Preloader;
